// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadMessages from "@insite/client-framework/Store/Data/Messages/Handlers/LoadMessages";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTable, { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableBody, DataTableCell, DataTableHead, DataTableHeader, DataTableRow, Link } from "@insite/mobius/index";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import Modal from "@store/MobiusOverrides/Modal/Modal";
import Select, { SelectPresentationProps, SelectProps } from "@store/MobiusOverrides/Select/Select";
import TextField, { TextFieldPresentationProps } from "@store/MobiusOverrides/TextField/TextField";
import Typography, {
    TypographyPresentationProps,
    TypographyProps,
} from "@store/MobiusOverrides/Typography/Typography";
import constants from "@store/constants";
import { addOrderComplaint, AddOrderComplaintApiParameter } from "@store/Framework/Types/OrderService";
import useForceUpdate from "@store/Framework/Common/Hooks/useForceUpdate";
import { convertFileToBase64 } from "@store/Framework/Common/Utilities/convertFileToBase64";
import validateRequiredDropdown from "@store/Framework/Common/Utilities/validateRequiredDropdown";
import FieldLabelAndTip from "@store/Library/Components/FieldLabelAndTip";
import RequestOrderComplaintProductList from "@store/Library/Components/OrderComplaint/RequestOrderComplaintProductList";
import FileUpload from "@store/MobiusOverrides/FileUpload/FileUpload";
import { tableGetEllipsisCellProps } from "@store/Themes/common/props/table";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridPresetGapStyles } from "@toolkit/Themes/common/mixins";
import React, { Dispatch, FC, SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { css } from "styled-components";

const enum fields {
    reasons = "reasons",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    reasonsTitle = "reasons", // This value is duplicated but content may be lost from the CMS if changed.
    fileImportMessage = "fileImportMessage",
    fileImportFormat = "fileImportFormat",
    fileImportMax = "fileImportMax",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.reasons]: {
            fields: {
                [fields.reasonsTitle]: string;
            };
        }[];
        [fields.fileImportMessage]: string;
        [fields.fileImportFormat]: string;
        [fields.fileImportMax]: number;
    };
}

export interface RequestOrderComplaintFormStyles {
    gridContainerWrapper?: GridContainerProps;
    leftGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
    wrapper?: InjectableCss;
    notesTextArea?: TextAreaProps;
    selectAreaWrapper?: InjectableCss;
    selectArea?: SelectPresentationProps;
    formBottomAreaGrid?: GridContainerProps;
    formBottomAreaItem?: GridItemProps;
    phoneField?: TextFieldPresentationProps;
    submitButton?: ButtonPresentationProps;
    labelTipText?: TypographyPresentationProps;
    labelOptionalText?: TypographyPresentationProps;
    productsAndFilesWrapper?: FlexWrapperPresentationProps;
    submitWrapper?: InjectableCss;
    filesItemWrapper?: InjectableCss;
    documentsTable?: DataTablePresentationProps;
    documentsItemTitleWrapper?: InjectableCss;
    documentsText?: TypographyPresentationProps;
    documentsFileWrapper?: FlexWrapperPresentationProps;
    deleteActionLink?: LinkPresentationProps;
    fileNameCell?: DataTableCellProps;
    infoTitleText?: TypographyProps;
    radioGroup?: RadioGroupProps;
}

export const requestOrderComplaintFormStyles: RequestOrderComplaintFormStyles = {
    gridContainerWrapper: {
        gap: 60,
        css: css`
            width: 100%;
            margin-top: ${pxToRem(32)};
            padding-top: ${pxToRem(32)};
            border-top: 2px solid ${getColor("common.border")};
        `,
    },
    leftGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    rightGridItem: {
        width: [12, 12, 12, 6, 6],
    },
    wrapper: {
        css: css`
            margin-bottom: ${pxToRem(20)};
            width: 100%;
        `,
    },
    notesTextArea: {
        css: css`
            margin-bottom: ${pxToRem(20)};
        `,
    },
    phoneField: {
        css: css`
            margin-bottom: ${pxToRem(20)};
        `,
    },
    selectAreaWrapper: {
        css: css`
            ${breakpointValues(["100%", null, "50%", null, null], "width", "up")}
            margin-bottom: ${pxToRem(20)};
        `,
    },
    formBottomAreaItem: { width: [12, 12, 6, 6, 6] },
    submitButton: {
        css: css`
            ${x => x.theme.button.primary.css}
            float: right;

            ${breakpointValues(["100%", null, "auto", null, null], "width")}
        `,
    },
    labelOptionalText: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
            margin-left: ${pxToRem(8)};
        `,
    },
    labelTipText: {
        variant: "p",
        css: css`
            margin-top: ${pxToRem(5)};
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smallest};
                font-weight: ${theme.design.typography.weight.base};
            `}
        `,
    },
    productsAndFilesWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    ${x => gridPresetGapStyles(x.theme.design.form.grid.base)}
                    width: 100%;
                `,
            },
            content: {
                css: css`
                    flex-direction: column;
                `,
            },
        },
    },
    submitWrapper: {
        css: css`
            border-top: 2px solid ${getColor("common.border")};
            margin-top: ${pxToRem(32)};
            padding-top: ${pxToRem(24)};
        `,
    },
    filesItemWrapper: {
        css: css`
            background: ${getColor("common.accent")};
            width: 100%;
            margin-top: ${pxToRem(32)};
            ${breakpointValues([pxToRem(16), null, pxToRem(32), null, null], "padding")};
        `,
    },
    documentsTable: {
        css: css`
            ${x => x.theme.dataTable.defaultProps?.css}
            border: ${pxToRem(2)} solid ${getColor("text")};
        `,
    },
    fileNameCell: mergeProps<DataTableCellProps>(tableGetEllipsisCellProps(0), {
        css: css`
            > ${StyledButton}, > ${TypographyStyle} {
                ${breakpointValues(pxToRemArray([170, 380, 500, 290, 360]), "max-width")}
            }
        `,
    }),
    documentsItemTitleWrapper: {
        css: css`
            padding-bottom: ${pxToRem(32)};
        `,
    },
    documentsText: {
        variant: "p",
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    documentsFileWrapper: {
        extendedStyles: {
            content: {
                css: css`
                    flex-direction: column;
                    gap: ${pxToRem(24)};
                `,
            },
        },
    },
    deleteActionLink: {
        typographyProps: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.smaller};
                display: none;
                ${breakpointValues(["none", "block", null, null, null], "display")};
            `,
        },
        icon: {
            position: "left",
            iconProps: {
                size: 18,
                color: "text.link",
                src: TrashFill,
                css: css`
                    margin-right: ${pxToRem(5)};
                `,
            },
        },
    },
    infoTitleText: {
        variant: "h5",
        as: "h3",
    },
    radioGroup: {
        horizontal: true,
        css: css`
            margin-bottom: ${pxToRem(20)};
        `,
    },
};

const styles = requestOrderComplaintFormStyles;

type Props = OwnProps;

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

type FileData = {
    filename: string;
    data: string | ArrayBuffer | null | undefined;
};

export const OrderComplaintContext = React.createContext<ContextType>({
    validators: {},
});

const RequestOrderComplaintForm: FC<Props> = ({ fields }) => {
    const { value: order } = useContext(OrderStateContext);
    const { orderLine, qtyNonConformancies } = useSelector(
        (state: ApplicationState) => state.greif.pages.orderComplaint,
    );
    const toasterContext = useContext(ToasterContext);
    const dispatch = useAppDispatch();

    const forceUpdate = useForceUpdate();

    const [validators] = useState<{ [key: string]: Validator | undefined }>({});
    const [selectedReason, setSelectedReason] = useState<string>("");
    const [reasonErrorMessage, setReasonErrorMessage] = useState<string>("");
    const [complaintDesc, setComplaintDesc] = useState<string>("");
    const [complaintFiles, setComplaintFiles] = useState<File[]>([]);
    const [isSafetyIssue, setIsSafetyIssue] = useState("false");
    const [isFoodIssue, setIsFoodIssue] = useState("false");
    const [haveSample, setHaveSample] = useState("true");
    const [complaintFilesData, setComplaintFilesData] = useState<any[]>([]);
    const [complaintFilesError, setComplaintFilesError] = useState<string>("");
    const [complaintClearProducts, setComplaintClearProducts] = useState<boolean>(false);
    const [complaintPhone, setComplaintPhone] = useState<string>("");
    const [complaintNumber, setComplaintNumber] = useState<string>("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [resetForm, setResetForm] = useState(false);

    const validateReason = (value: string) => {
        const errorMessage = validateRequiredDropdown(value, translate("Complaint Reasons"));
        setReasonErrorMessage(errorMessage || "");
        return !errorMessage;
    };

    useEffect(() => {
        validators.reason = () => validateReason(selectedReason);
    }, [selectedReason]);

    if (!order) {
        return null;
    }

    const reasonHandler: SelectProps["onChange"] = event => {
        setSelectedReason(event.target.value);
        validateReason(event.target.value);
    };

    const problemHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setComplaintDesc(event.target.value);
    };

    const phoneHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setComplaintPhone(event.target.value);
    };
    const numberHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setComplaintNumber(event.target.value);
    };

    const readFileAsText = (file: File) => {
        return convertFileToBase64(file);
    };

    const handleQuestion = useCallback(
        (setState: Dispatch<SetStateAction<string>>) => (event: React.ChangeEvent<HTMLInputElement>) => {
            setState(event.target.value);
        },
        [],
    );

    const fileUploadHandler: React.ChangeEventHandler<any> = event => {
        event.preventDefault();

        const uploadedFilesLength = Array.from(event.target.files).length;
        const alreadyUploadFilesLength = complaintFiles.length;

        if (uploadedFilesLength + alreadyUploadFilesLength > fields.fileImportMax) {
            setComplaintFilesError(
                translate(
                    "Please select fewer files or remove files from the list above before adding new ones. Maximum allowed is {0}.",
                    String(fields.fileImportMax),
                ),
            );
            return;
        }
        complaintFilesError ? setComplaintFilesError("") : null;

        Array.from(event.target.files).forEach((file: any) => {
            complaintFiles.push(file);
        });

        if (event.target.files[0] !== null) {
            const readers = [];
            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files[i];
                readers.push(readFileAsText(file));
            }
            Promise.all(readers).then(files => {
                files.forEach(file => {
                    complaintFilesData.push(file);
                });
            });
        }

        forceUpdate();
        event.target.value = null;
    };

    const handleDocumentRemove = (fileName: string) => {
        const indexToRemove = complaintFiles?.map(i => i.name).indexOf(fileName);
        complaintFiles.splice(indexToRemove, 1);
        setComplaintFiles([...complaintFiles]);

        complaintFilesData.splice(indexToRemove, 1);
        setComplaintFilesData([...complaintFilesData]);

        complaintFiles.length <= fields.fileImportMax && setComplaintFilesError("");

        forceUpdate();
    };

    const closeOrderComplaintModal = () => {
        setIsModalOpen(false);
    };

    const formReset = () => {
        setSelectedReason("");
        setComplaintDesc("");
        setIsSafetyIssue("false");
        setIsFoodIssue("false");
        setHaveSample("false");
        setComplaintPhone("");
        setComplaintNumber("");
        setComplaintFiles([]);
        setComplaintFilesData([]);
        setResetForm(true);
        setComplaintClearProducts(true);
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const widgetValidators: Validator[] = [];

        Object.keys(validators).forEach(key => {
            const validator = validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });

        const results = widgetValidators.map(v => v());

        if (!results.every(o => o)) {
            return;
        }

        if (!!orderLine && complaintFiles.length <= 5) {
            const sentFiles: FileData[] = [];
            for (let i = 0; i < complaintFiles.length; i++) {
                const file = complaintFiles[i];
                const cleanedFile = complaintFilesData[i].replace("-", "+").replace("_", "/").match(`(?<=base64,).*`);
                sentFiles.push({ filename: file.name, data: cleanedFile[0] });
            }

            const formData = {
                orderComplaintModel: {
                    erpNumber: order.id,
                    type: selectedReason,
                    complaintDescription: complaintDesc,
                    phoneNumber: complaintPhone,
                    customerComplaintNumber: complaintNumber,
                    documents: sentFiles,
                    orderHistoryLineId: orderLine?.id,
                    isFoodSafetyIssue: isFoodIssue === "true",
                    isSafetyIssue: isSafetyIssue === "true",
                    isSample: haveSample === "true",
                    complaintQuantity: qtyNonConformancies,
                },
            } as AddOrderComplaintApiParameter;

            setIsSubmitting(true);

            addOrderComplaint(formData)
                .then(e => {
                    if (e.successful) {
                        toasterContext.addToast({
                            body: translate("OrderComplaint_ComplaintSent"),
                            messageType: "success",
                        });
                        dispatch(loadMessages({}));
                        formReset();
                        setTimeout(() => {
                            setResetForm(false);
                            setComplaintClearProducts(false);
                        }, 2000);
                    } else {
                        toasterContext.addToast({
                            body: translate("OrderComplaint_ComplaintError"),
                            messageType: "warning",
                        });
                    }
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {
            setIsModalOpen(true);
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <OrderComplaintContext.Provider value={{ validators }}>
                <form id="orderComplaintForm" onSubmit={handleFormSubmit} style={{ width: "100%" }}>
                    <GridContainer {...styles.gridContainerWrapper}>
                        <GridItem {...styles.leftGridItem}>
                            <StyledWrapper {...styles.selectAreaWrapper}>
                                <Select
                                    {...styles.selectArea}
                                    label={translate("Complaint Reasons")}
                                    value={selectedReason}
                                    onChange={reasonHandler}
                                    error={reasonErrorMessage}
                                    required
                                >
                                    <option value="" disabled>
                                        {translate("Select Reason")}
                                    </option>
                                    {fields.reasons.map((r, id) => (
                                        <option key={id} value={r.fields.reasons}>
                                            {translate(r.fields.reasons || "")}
                                        </option>
                                    ))}
                                </Select>
                            </StyledWrapper>
                            <TextArea
                                label={translate("Description of Non-Conformancies")}
                                value={complaintDesc}
                                rows={5}
                                placeholder={translate(
                                    "Please describe the complaint in detail, including the number of defects and where it was found. Attach the MSDS if applicable.",
                                )}
                                required
                                onChange={problemHandler}
                                {...styles.notesTextArea}
                            />
                            <TextField
                                {...styles.phoneField}
                                type="phone"
                                label={translate("Phone Number")}
                                value={complaintPhone}
                                data-test-selector="OrderComplaint_Phone"
                                placeholder={translate("(555) 555-5555")}
                                onChange={phoneHandler}
                                maxLength={19}
                            />
                            <TextField
                                {...styles.phoneField}
                                type="text"
                                label={translate("Customer complaint number")}
                                value={complaintNumber}
                                data-test-selector="OrderComplaint_Number"
                                placeholder={translate("Enter your complaint number here, if you have one")}
                                onChange={numberHandler}
                                maxLength={19}
                            />
                            <RadioGroup
                                {...styles.radioGroup}
                                label={`${translate("Did this complaint result in a safety issue")} :`}
                                value={isSafetyIssue}
                                onChangeHandler={handleQuestion(setIsSafetyIssue)}
                            >
                                <Radio value="true" key="true">
                                    {translate("Yes")}
                                </Radio>
                                <Radio value="false" key="false">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <RadioGroup
                                {...styles.radioGroup}
                                label={`${translate("Is this complaint a food safety related issue")} :`}
                                value={isFoodIssue}
                                onChangeHandler={handleQuestion(setIsFoodIssue)}
                            >
                                <Radio value="true" key="true">
                                    {translate("Yes")}
                                </Radio>
                                <Radio value="false" key="false">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <RadioGroup
                                {...styles.radioGroup}
                                label={`${translate(
                                    "Do you have a sample of the non-conformity available if required",
                                )} :`}
                                value={haveSample}
                                onChangeHandler={handleQuestion(setHaveSample)}
                            >
                                <Radio value="true" key="true">
                                    {translate("Yes")}
                                </Radio>
                                <Radio value="false" key="false">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                        </GridItem>
                        <GridItem {...styles.rightGridItem}>
                            <FlexWrapper {...styles.productsAndFilesWrapper}>
                                <RequestOrderComplaintProductList clearProducts={complaintClearProducts} />
                                <StyledWrapper {...styles.filesItemWrapper}>
                                    <Typography {...styles.infoTitleText}>{translate("Documents")}</Typography>
                                    <StyledWrapper {...styles.documentsItemTitleWrapper}>
                                        <Typography {...styles.documentsText}>
                                            {translate(`${fields.fileImportMessage}`)}
                                        </Typography>
                                    </StyledWrapper>
                                    <FlexWrapper {...styles.documentsFileWrapper}>
                                        {complaintFiles && complaintFiles.length === 0 ? (
                                            <Typography {...styles.documentsText}>
                                                {translate("No document uploaded.")}
                                            </Typography>
                                        ) : (
                                            <DataTable {...styles.documentsTable}>
                                                <DataTableHead>
                                                    <DataTableHeader>{translate("Uploaded Documents")}</DataTableHeader>
                                                    <DataTableHeader>{translate("Action")}</DataTableHeader>
                                                </DataTableHead>
                                                <DataTableBody>
                                                    {complaintFiles?.map((document, index) => (
                                                        <DataTableRow key={`${document.name}_${index}`}>
                                                            <DataTableCell {...styles.fileNameCell}>
                                                                <Typography>{document.name}</Typography>
                                                            </DataTableCell>
                                                            <DataTableCell>
                                                                <Link
                                                                    {...styles.deleteActionLink}
                                                                    onClick={() => handleDocumentRemove(document.name)}
                                                                >
                                                                    {translate("Delete")}
                                                                </Link>
                                                            </DataTableCell>
                                                        </DataTableRow>
                                                    ))}
                                                </DataTableBody>
                                            </DataTable>
                                        )}
                                        <FileUpload
                                            label={
                                                <FieldLabelAndTip
                                                    label={translate("Upload Documents")}
                                                    optional
                                                    optionalLabel={translate(
                                                        "Maximum {0} files",
                                                        String(fields.fileImportMax),
                                                    )}
                                                />
                                            }
                                            onChange={fileUploadHandler}
                                            accept={fields.fileImportFormat}
                                            disabled={complaintFiles.length >= fields.fileImportMax}
                                            formReset={resetForm}
                                            multiple
                                            error={complaintFilesError}
                                        />
                                    </FlexWrapper>
                                </StyledWrapper>
                            </FlexWrapper>
                        </GridItem>
                    </GridContainer>
                    <StyledWrapper {...styles.submitWrapper}>
                        <Button {...styles.submitButton} type="submit" disabled={isSubmitting}>
                            {translate("Submit")}
                        </Button>
                    </StyledWrapper>
                </form>
                <Modal
                    size={500}
                    headline={translate("Order Complaint Document")}
                    isOpen={isModalOpen}
                    handleClose={closeOrderComplaintModal}
                >
                    <Typography>{siteMessage("OrderComplaint_CantSend")}</Typography>
                </Modal>
            </OrderComplaintContext.Provider>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RequestOrderComplaintForm,
    definition: {
        allowedContexts: ["OrderComplaintPage" as any],
        group: constants.widgetGroup.orderComplaint,
        displayName: "Order Complaint Form",
        fieldDefinitions: [
            {
                name: fields.reasons,
                editorTemplate: "ListField",
                tooltip: "Please add the reason of the complaint",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.reasonsTitle,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.fileImportMax,
                displayName: "Maximum of files allowed",
                fieldType: "General",
                editorTemplate: "IntegerField",
                defaultValue: 5,
            },
            {
                name: fields.fileImportMessage,
                displayName: "File Import Hint Message",
                fieldType: "General",
                editorTemplate: "MultilineTextField",
                defaultValue: "You can upload and attach multiple relevant files.",
            },
            {
                name: fields.fileImportFormat,
                displayName: "Allowed File Formats",
                fieldType: "General",
                editorTemplate: "TextField",
                tooltip: "Use comma-separated values. i.e.: .pdf, .zip",
                defaultValue: ".pdf, .zip, .jpg, .jpeg, .png",
            },
        ],
    },
};

export default widgetModule;
